
























import Vue from "vue";
import { mapState } from "vuex";

function emptyProject() {
  return {
    name: ""
  };
}

export default Vue.extend({
  data() {
    return {
      newProject: emptyProject()
    };
  },
  computed: mapState(["projects"]),
  methods: {
    createProject(newProject: any) {
      this.$store.dispatch("createProject", newProject);
      this.newProject = emptyProject();
    },
    setCurrent(project: any) {
      this.$store.commit("setCurrentProject", project);
    },
    remove(project: any) {
      this.$store.dispatch("deleteProject", project.id);
    }
  }
});
